import { createFetchInstance } from 'codekit';

export const api = createFetchInstance({
	baseUrl: '/api',
	onBeforeRequest: (options) => options,
	onResponse: (response) => response,
});
